import { Route, Switch } from 'react-router-dom';
import { Container } from 'yoso';
import { Footer } from '~/components/Footer';
export const noFooterPaths = [
  '/invitation',
  '/membership/item/citizen/levelup/go',
  '/membership/item/friend/levelup/go',
];

export const FooterRouteSwitch = () => (
  <Switch>
    <Route path={noFooterPaths} />
    <Route>
      <div className="layout-footer-inner">
        <Container margin="auto">
          <Footer />
        </Container>
      </div>
    </Route>
  </Switch>
);
